import Paths from '@/configs/router/paths';
import URLs from '@/scripts/request/URLs';
import { localUrl } from '@/configs/env';
import { isDesktop } from './helpers';

export const OAuth = {
  getGoogleConfig() {
    const redirect_uri = isDesktop()
      ? `${localUrl}${Paths.AUTH_CALLBACK}`
      : `${localUrl}${Paths.LOGIN}`;

    return {
      client_id: import.meta.env.VITE_CLIENT_ID_GOOGLE,
      client_secret: import.meta.env.VITE_SECRET_GOOGLE,
      redirect_uri,
      response_type: 'code',
      scope:
        // 'openid email profile'
        // 'openid email profile https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive'
        'openid https://www.googleapis.com/auth/drive.appdata',
      access_type: 'offline',
      prompt: 'select_account',
    };
  },
  testEmial() {
    const redirect_uri = isDesktop()
      ? `${localUrl}${Paths.AUTH_CALLBACK}`
      : `${localUrl}${Paths.LOGIN}`;
    const url = new URL(`https://accounts.google.com/o/oauth2/v2/auth`);
    url.searchParams.set('client_id', import.meta.env.VITE_CLIENT_ID_GOOGLE);
    url.searchParams.set('redirect_uri', redirect_uri);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set(
      'scope',
      // 'openid email profile'
      // 'openid email profile https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive'
      'email'
    );
    url.searchParams.set('access_type', 'offline');
    url.searchParams.set('prompt', '');

    window.location.href = url.toString();
  },
  getAppleConfig() {
    const redirect_web_uri = isDesktop()
      ? `${localUrl}${Paths.AUTH_CALLBACK}`
      : `${localUrl}${Paths.LOGIN}`;
    const apiUrl = new URLs('/api/v1/user/login/apple/callback');
    // const url = new URL(`https://appleid.apple.com/auth/authorize`);
    // url.searchParams.set('client_id', import.meta.env.VITE_CLIENT_ID_APPLE);
    // url.searchParams.set('redirect_uri', apiUrl.href);
    // url.searchParams.set('response_type', 'code');
    // url.searchParams.set('response_mode', 'form_post');
    // url.searchParams.set('scope', 'email name');
    // url.searchParams.set('state', encodeURIComponent(redirect_web_uri));

    //window.location.href = url.toString();
    return {
      client_id: import.meta.env.VITE_CLIENT_ID_APPLE,
      redirect_uri: apiUrl.href,
      response_type: 'code',
      response_mode: 'form_post',
      scope: 'email name',
      state: encodeURIComponent(redirect_web_uri),
      //usePopup: false,
      evnironment: import.meta.env.VITE_APP_APPLE_ENV,
      apiToken: import.meta.env.VITE_CLOUD_KIT_API_TOKEN,
      containerIdentifier: import.meta.env.VITE_CLOUD_KIT_CONTAINER_IDENTIFIER,
    };
  },
};
